import { z } from 'zod'

export const ALICUOTAS_IVA_VALUES = ['0', '10.5', '21', '27', 'exento', 'no_gravado'] as const

const presupuestoItemSchema = z.object({
  servicio_id: z.string().min(1, 'Selecciona un servicio'),
  cantidad: z.number().min(1, 'Mínimo 1'),
  precio_unitario: z.number().min(0, 'El precio no puede ser negativo'),
  descuento_porcentaje: z.number().min(0, 'Mínimo 0%').max(100, 'Máximo 100%'),
  subtotal: z.number(),
  descripcion: z.string().nullable().optional(),
})

export const presupuestoSchema = z.object({
  // Client selection mode
  modo_cliente: z.enum(['existente', 'nuevo']),

  // Client data
  cliente_id: z.string().nullable().optional(),
  cliente_nombre: z.string().min(1, 'El nombre del cliente es requerido'),
  cliente_cuit: z.string().nullable().optional(),
  cliente_email: z.string().email('Email inválido').nullable().optional().or(z.literal('')),
  cliente_condicion_iva: z.string().nullable().optional(),
  tipo_persona: z.enum(['fisica', 'juridica', 'sucesion']),

  // Admin/Representante (juridica o sucesion)
  admin_nombre: z.string().nullable().optional(),
  admin_cuit: z.string().nullable().optional(),

  // Presupuesto data
  fecha: z.string().min(1, 'La fecha es requerida'),
  validez_dias: z.number().min(1, 'Mínimo 1 día'),
  condiciones_pago: z.string().nullable().optional(),

  // Items
  items: z.array(presupuestoItemSchema).min(1, 'Agrega al menos un servicio'),

  // Totals
  descuento_porcentaje: z.number().min(0, 'Mínimo 0%').max(100, 'Máximo 100%'),
  iva_porcentaje: z.string(), // String because it's from a select

  // Notes
  notas: z.string().nullable().optional(),
}).refine(
  (data) => data.modo_cliente !== 'existente' || (data.cliente_id != null && data.cliente_id !== ''),
  { message: 'Seleccioná un cliente', path: ['cliente_id'] }
)

export type PresupuestoFormValues = z.infer<typeof presupuestoSchema>
export type PresupuestoItemValues = z.infer<typeof presupuestoItemSchema>
